// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".time-filter-panel .filter-section .filter-label[data-v-fbebb8aa]{display:flex;align-items:center;font-size:.875rem}", ""]);
// Exports
module.exports = exports;
